import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Loader from '../../components/Loader'
import { getById } from '../../lib/RestApi/customApiHandler'
import AddBusinessType from './AddBusinessType'
export default function EditBusinessType() {
  const params = useParams()
  const [businessType, setBusinessType] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getById('/business-type', params.businessTypeId).then((res) => {
      setBusinessType(res.data)
      setLoading(false)
    })
  }, [params.businessTypeId])

  return <> {loading ? <Loader /> : <AddBusinessType businessType={businessType} />} </>
}
